module.exports = __webpack_public_path__ + "img/3.25d1083b.png";